export default __webpack_public_path__ + "static/media/discover.78b0f9ec.svg";